<script setup lang="tsx">
import { ref } from "vue";
import { useLocalStorage } from "@zyzgroup/core-web";
import { mapState, context } from "../../context/context";
import { dialog, loading } from "../../globalTeleport";
import { useRouter } from "../../hooks";
import Button from "../form/Button.vue";
import Text from "../form/Text.vue";
import ContentSpaceBetween from "../layout/ContentSpaceBetween.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Button, Text, ContentSpaceBetween },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    billsn: string;
  }>(),
  {
    billsn: ""
  }
);

const emits = defineEmits<{
  (event: "reloadOrder", ordersn: string): void;
}>();

const mappedState = mapState([
  "user.openid",
  "bill.sn",
  "bill.merchsn",
  "park.isROBOT",
  "color.foregroundPattern",
  "color.panelBorderPattern",
  "color.redCommon",
  "color.redSecondaryCommon",
  "color.redSecondaryBorderCommon"
]);

const router = useRouter();

// https://yaoyao.cebbank.com/LifePayment/webApp/h5/router.html?transType=01&canalType=13&canal=njczfs&ItemCode=860729765&userNo=32010025101035852255
function gotoPay() {
  context.ds.immediately(loading);
  const billsn = props.billsn || mappedState["bill.sn"].value;
  context.axios
    .post(
      // `/api/v6/bill/${billsn}/pay`,
      `/api/v6/bill/${billsn}/paywithmerch`,
      {
        openid: mappedState["user.openid"].value,
        type: "U",
        merchsn: mappedState["bill.merchsn"].value
      },
      {
        retry: 0,
        cache: 0
      }
    )
    .then((result) => {
      if (result.data.path) {
        context.ds.closeLast();

        // 跳转到第三方链接
        // location.href = result.data.path;

        // if (mappedState["park.isROBOT"].value) {
        //   push("/unlocking");
        // } else {
        context.store.dispatch({
          type: "SET_RESULT",
          payload: {
            status: "success",
            title: "支付成功",
            subtitle: "请及时驶离车位，否则将继续计费"
          }
        });
        router.push("/result");
        // }
      } else {
        context.ds.immediately(dialog, {
          title: "接口出错",
          content: "接口未返回跳转链接 path !",
          confirmText: "知道了",
          mode: "mini",
          onClose: () => {}
        });
      }
    })
    .catch((result) => {
      context.ds.immediately(dialog, {
        title: "接口出错",
        content: result.data.error,
        confirmText: "知道了",
        mode: "mini",
        onClose: () => {
          const ordersn = result.data.sn ? String(result.data.sn) : "";
          // 800 {"error":"预订单已经过期，请重新生成订单！","data":{"sn":170172}}
          // 600 {"error":"支付单已经有明确的商户号！"}
          // if (result.status == 800) {
          emits("reloadOrder", ordersn);
          // }
        }
      });
    });
}

const { get, set } = useLocalStorage("xg-footer-warn");
const showWarn = ref(!get());
function closeWarn() {
  set("hide");
  showWarn.value = false;
}
</script>

<template>
  <div
    class="xg-footer"
    :style="{
      backgroundColor: `${mappedState['color.foregroundPattern'].value}`,
      borderTop: `1px solid ${mappedState['color.panelBorderPattern'].value}`
    }"
  >
    <ContentSpaceBetween
      v-if="showWarn"
      class="xg-footer-warn"
      :style="{
        color: mappedState['color.redCommon'].value,
        backgroundColor: mappedState['color.redSecondaryCommon'].value,
        border: `1px solid ${mappedState['color.redSecondaryBorderCommon'].value}`
      }"
    >
      <Text
        type="warn"
        :color="mappedState['color.redCommon'].value"
      >
        上车前，请确认车底翻板已降下完成。
      </Text>
      <Button
        colorPattern="red"
        mode="transparent"
        size="tertiary"
        :capsule="true"
        :backgroundColor="mappedState['color.foregroundPattern'].value"
        @throttledClick="closeWarn"
      >
        不再提醒
      </Button>
    </ContentSpaceBetween>
    <div class="xg-footer-inner">
      <Button
        width="100%"
        @throttledClick="gotoPay"
      >
        去支付
      </Button>
    </div>
  </div>
</template>

<style scoped>
.xg-footer {
  position: relative;
  box-sizing: border-box;
}
.xg-footer-warn {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  transform: translate(0, -100%);
  font-size: 14px;
  box-sizing: border-box;
  padding: 6px var(--yz-padding-horizontal);
}
.xg-footer-inner {
  box-sizing: border-box;
  width: 100%;
  padding: var(--yz-padding-vertical) var(--yz-padding-horizontal);
}
</style>
